export const blogList = [
  {
    id: 1,
    title: "جیمز وب از ادغام کهکشانی عکس گرفت",
    category: "کهکشان",
    subCategory: ["کهکشان", "سیارات", "جیمز وب"],
    description:
      "در واقع Arp 220 دو کهکشان مارپیچی در حال ادغام است که در نور فروسرخ می‌درخشد و به یک هدف ایده‌آل برای تلسکوپ جیمز وب محسوب می‌شود. این کهکشان فروسرخ فوق‌العاده درخشان(ULIRG) دارای روشنایی بیش از یک تریلیون خورشید است. در حالی که، کهکشان راه شیری ما دارای درخشندگی بسیار کمتری در حدود ده میلیارد خورشید است.",
    homeDescription: "در واقع Arp 220 دو کهکشان مارپیچی در حال ادغام است که در نور فروسرخ ...",
    authorName: "ادمین",
    authorAvatar: "/assets/images/author.jpg",
    createdAt: "May 11, 2023",
    cover: "/assets/images/image.jpeg",
  },
  {
    id: 2,
    title: "فیلم از مریخ",
    category: "مریخ",
    subCategory: ["مریخ", "منظومه شمسی", "سیارات"],
    description:
      "پاسخ در اطلاعاتی هست که این کاوشگر با کمک ماهواره‌های حول مریخ می‌تواند به زمین ارسال کند که کل آن ۲۵۰ مگابیت در روز است، و همه آن هم به عکس‌هاو فیلم های گرفته شده اختصاص نمی‌یابد و بخشی از پهنای باند به اطلاعات دیگر جمع‌آوری شده اختصاص می‌یابد پس اگر بخواهیم یک فیلم کوتاه ۵ دقیقه ای به زمین بفرستیم که حجم آن فقط ۲۵۰ مگابایت باشد (هر بایت ۸ بیت هست ) باید حداقل ۸ روز تمام کل پروژه فقط صرف ارسال این فیلم شود که بار علمی زیادی هم ندارد .",
    homeDescription: "پاسخ در اطلاعاتی هست که این کاوشگر با کمک ماهواره‌های حول مریخ می‌تواند ...",
    authorName: "ادمین",
    authorAvatar: "/assets/images/author.jpg",
    createdAt: "May 11, 2023",
    cover: "/assets/images/photo_5940541684720974326_x.jpg",
  },
  {
    id: 3,
    title: "آب در مریخ ۴۰۰ هزار سال قبل",
    category: "مریخ",
    subCategory: ["مریخ", "منظومه شمسی", "کاوشگر"],
    description:
      "دانشمندان با مطالعه داده‌های مریخ‌نورد چینی «ژارونگ» (Zhurong) برای اولین بار لایه‌های شکاف‌خورده‌ای روی تپه‌های شنی کوچک مریخ مشاهده کرده‌اند که نشان می‌دهد سیاره سرخ تا ۴۰۰ هزار سال پیش یک جهان آبی غنی از نمک بوده است. بر اساس مقاله‌ای علمی که به تازگی منتشر شده است، دانشمندان می‌گویند آب مریخ نقش مهمی در ایجاد ویژگی‌های جالب و خیره‌کننده سطح این سیاره روی تپه‌های شنی مینیاتوری داشته است.",
    homeDescription: "دانشمندان با مطالعه داده‌های مریخ‌نورد چینی «ژارونگ» (Zhurong) برای اولین بار ...",
    authorName: "ادمین",
    authorAvatar: "/assets/images/author.jpg",
    createdAt: "May 11, 2023",
    cover: "/assets/images/photo_5940595762654198683_y.jpg",
  },
  {
    id: 4,
    title: "حلقه های زحل",
    category: "زحل",
    subCategory: ["زحل", "منظومه شمسی", "هیدروژن"],
    description:
      "مشاهدات دانشمندان نشان می‌دهد که حلقه‌های زحل این سیاره را گرم می‌کنند.به گفتۀ محققان، ذرات موجود در حلقه‌ها به جو می‌رسند، به هیدروژن آنجا برخورد می‌کنند و آن را گرم می‌کننداما هیدروژن بسیار زیادی نیز وجود دارد که علت آن را نمی‌دانیم.",
    homeDescription: "مشاهدات دانشمندان نشان می‌دهد که حلقه‌های زحل این سیاره را گرم می‌کنند.به گفتۀ ...",
    authorName: "ادمین",
    authorAvatar: "/assets/images/author.jpg",
    createdAt: "May 11, 2023",
    cover: "/assets/images/field_image_saturn.jpg",
  },
  {
    id: 5,
    title: "سیاه چاله‌ ای ۳۰ میلیارد برابر خورشید",
    category: "سیاه چاله",
    subCategory: ["جرم", "خورشید", "سیاه چاله"],
    description:
      "گروهی از ستاره‌شناسان از روش جدیدی برای کشف یکی از بزرگترین سیاه‌چاله‌های تاکنون کشف‌شده، استفاده کرده‌اند . این گروه به رهبری دانشمندان دانشگاه دورهام در بریتانیا از ترکیبی از همگرایی گرانشی (gravitational lensing) و شبیه‌سازی‌های ابررایانه‌ای برای به دست آوردن بینش جدیدی در مورد این غول کیهانی که در فاصله صدها میلیون سال نوری از زمین قرار دارد، استفاده کردند . آنها در نهایت موفق به کشف یک ابرسیاه‌چاله شدند که بیش از ۳۰ میلیارد برابر خورشید ما جرم دارد .",
    homeDescription: "گروهی از ستاره‌ شناسان از روش جدیدی برای کشف یکی از بزرگترین سیاه‌ چاله‌ ای ...",
    authorName: "ادمین",
    authorAvatar: "/assets/images/author.jpg",
    createdAt: "May 11, 2023",
    cover: "/assets/images/5831698.jpg",
  },
  {
    id: 6,
    title: "لایه پنجم پنهان در هسته داخلی زمین",
    category: "زمین",
    subCategory: ["پنهان", "منظومه شمسی", "زمین"],
    description:
      "محققان دانشگاه ملی استرالیا، بتازگی از کشف یک لایه جدید در هسته زمین خبر دادند که می‌تواند آغازگر فصلی جدید برای حل معماهای منظومه شمسی باشد. این کشف با مطالعه امواج لرزه‌ای امکان‌پذیر شد. جدیدترین یافته‌ها نشان می‌دهند که «درونی‌ترین هسته داخلی زمین» ممکن است یک توپ آهنی با قطر حدود ۶۵۰ کیلومتری درون هسته داخلی زمین باشد. دانشمندان می‌گویند این کشف می‌تواند نشان دهندۀ یک رویداد دراماتیک در تاریخ سیاره ما باشد و درک ما از پیدایش و تکامل زمین را بهبود ببخشد.",
    homeDescription: "محققان دانشگاه ملی استرالیا، بتازگی از کشف یک لایه جدید در هسته زمین خبر ...",
    authorName: "ادمین",
    authorAvatar: "/assets/images/author.jpg",
    createdAt: "May 12, 2023",
    cover: "/assets/images/image (1).jpeg",
  },
  {
    id: 7,
    title: "تلسکوپ چگونه اختراع شد",
    category: "تلسکوپ",
    subCategory: ["گالیله", "کهکشان راه شیری", "تلسکوپ"],
    description:
      "اولین لکه بینی در سال 1607 در هلند ساخته شد. اما قبل از آن، در سال 1509، لئوناردو داوینچی در یادداشت های خود نقاشی هایی از ساده ترین تلسکوپ عدسی انجام داد و پیشنهاد کرد از طریق آن به ماه نگاه کنید. در سال 1609، گالیله ایتالیایی برای اولین بار با تلسکوپ به آسمان اشاره کرد و توانست دهانه های ماه، ستارگان مجزای راه شیری و ماهواره های مشتری را ببیند. بنابراین او آن را به یک تلسکوپ تبدیل کرد. گالیله مشاهدات خود را در کتاب The Starry Messenger توضیح داد که در جامعه علمی سروصدا کرد. این لحظه یکی از نقاط عطف در توسعه نجوم به عنوان یک علم جهان در نظر گرفته می شود. (نمونه اول نقاشی دیواری جوزپه برتینیگالیله گالیله تلسکوپ خود را در ونیز نشان می دهد است). اولین تلسکوپ مونتاژ شده توسط گالیله دارای بزرگنمایی سه برابری بود. بعداً او توانست به تقریب 32 برابری دست یابد. در آینده، دانشمندان متوجه شدند که افزایش فاصله کانونی کیفیت تصویر را بهبود می بخشد. ",
    homeDescription: "اولین لکه بینی در سال 1607 در هلند ساخته شد. اما قبل از آن، در سال 1509، لئوناردو داوینچی در ...",
    authorName: "ادمین",
    authorAvatar: "/assets/images/author.jpg",
    createdAt: "May 13, 2023",
    cover: "/assets/images/photo_5942506563539417642_y.jpg",
  },
  {
    id: 8,
    title: "هلیوم ۳",
    category: "هلیوم",
    subCategory: ["عنصر", "کره ماه", "هلیوم"],
    description:
      "محققان دانشگاه ملی استرالیا، بتازگی از کشف یک لایه جدید در هسته زمین خبر دادند که می‌تواند آغازگر فصلی جدید برای حل معماهای منظومه شمسی باشد. این کشف با مطالعه امواج لرزه‌ای امکان‌پذیر شد. جدیدترین یافته‌ها نشان می‌دهند که «درونی‌ترین هسته داخلی زمین» ممکن است یک توپ آهنی با قطر حدود ۶۵۰ کیلومتری درون هسته داخلی زمین باشد. دانشمندان می‌گویند این کشف می‌تواند نشان دهندۀ یک رویداد دراماتیک در تاریخ سیاره ما باشد و درک ما از پیدایش و تکامل زمین را بهبود ببخشد.",
    homeDescription: "هلیوم ۳ یکی از ایزتوپ های کمیابی هست که قرار است از ماه استخراج شود ...",
    authorName: "ادمین",
    authorAvatar: "/assets/images/author.jpg",
    createdAt: "May 13, 2023",
    cover: "/assets/images/photo_5969866372798332782_x.jpg",
  },
  {
    id: 9,
    title: "چرا آسمان را آبى مى بينيم",
    category: "آسمان",
    subCategory: ["ذره", "رنگ", "آسمان"],
    description:
      "رنگ آبی آسمان ناشی از برهم کنش نور با مولکول های گازی که در جو زمین وجود دارند ایجاد می شود. به این فرایند، پراکندگی نور گفته می شود. رایج ترین تئوری مورد قبول که رنگ آبی آسمان را توضیح می دهد، پراکندگی نور توسط اتمسفر است. اتمسفر حاوی گازها و ذراتی می باشد که با ذرات سبک دیگر برخورد می کند و در جهت ها و شدت های مختلف پراکنده می شود. نور از طیف هفت رنگ مختلف تشکیل شده است. این رنگ ها عبارت هستند از قرمز، نارنجی، زرد، سبز، آبی، نیلی و بنفش؛  که ذرات موجود در آنها به صورت ناهموار پراکنده شده اند. نور آبی در طول موج های(طول موج فاصله بین دو نقطه هم فاز یا به عبارتی فاصله ای که بین دو قله موج ها وجود دارد.) کوتاه تر حرکت می کند و در هنگام گذر نور خورشید از هوا، بیشتر از رنگ های دیگر پراکنده می شود. همچنین، رنگ آبی نسبت به دیگر رنگ ها مانند قرمز، دارای فرکانس بالاتری می باشد و بیشتر پراکنده می شود. بنابر همین اصل ما آسمان را به رنگ آبی مشاهده می کنیم.",
    homeDescription: "رنگ آبی آسمان ناشی از برهم کنش نور با مولکول های گازی که در جو زمین وجود دارند ایجاد ...",
    authorName: "ادمین",
    authorAvatar: "/assets/images/author.jpg",
    createdAt: "May 15, 2023",
    cover: "/assets/images/58995edb-6c6a-411e-9382-ab16ab5e473d.jfif",
  },
  {
    id: 10,
    title: "ستاره های نوترونی",
    category: "ستاره",
    subCategory: ["ذره", "نوترونی", "ستاره"],
    description:
      "ستاره های نوترونی بازمانده ستارگان پرجرمی هستند که سوختشان تمام شده است. زمانی که اواخر عمر یک ستاره پرجرم فرا می رسد نیروی جاذبه آن به قدری زیاد می شود که الکترونها و پروتونهای آن گداخت می کنند. با گداخت الکترونها و پروتونها، سطح این ستاره را لایه ای از نوترونها می پوشاند. رمبش یا فرو ریختن این ستاره موجب افزایش شدید سرعت گردش آن می شود. به طوری که این نوع ستاره در هر ثانیه، بارها به دور محور خود می گردد، در حالی که خورشید هر 27 روز یک بار یک دور محور خود می چرخد. سریع ترین ستاره نوترونی با سرعتی برابر 716 بار در ثانیه گردش می کند.",
    homeDescription: "ستاره های نوترونی بازمانده ستارگان پرجرمی هستند که سوختشان تمام شده است. زمانی که ...",
    authorName: "ادمین",
    authorAvatar: "/assets/images/author.jpg",
    createdAt: "May 17, 2023",
    cover: "/assets/images/2021-5-neutron-stars-638bb4b8b90c494dc77f5488.jpg",
  },
  {
    id: 11,
    title: "سایکی 16",
    category: "سیارک",
    subCategory: ["سیاره", "سیارک", "سایکی"],
    description:
      "سایکی ۱۶ (به انگلیسی: 16 Psyche ) شانزدهمین سیارک کشف شده‌است که در ۱۷ مارس ۱۸۵۲ و در ناپل کشف شد. این سیارک به دلیل داشتن مقادیر هنگفتی آهن و نیکل مورد توجه ناسا قرار دارد. اطلاعات اضافی به همراه عکس این سیارک را در تصویر بالا می توانید مشاهده کنید.",
    homeDescription: "سایکی ۱۶ (به انگلیسی: 16 Psyche ) شانزدهمین سیارک کشف شده‌است که در ۱۷ مارس ۱۸۵۲ و در ناپل ...",
    authorName: "ادمین",
    authorAvatar: "/assets/images/author.jpg",
    createdAt: "May 23, 2023",
    cover: "/assets/images/Psyche-16-Metal-Asteroid.jpg",
  },
];
